
namespace GeniuzPOS.Supplier {

    @Serenity.Decorators.registerClass()
    export class CsSupplTypeDialog extends Serenity.EntityDialog<CsSupplTypeRow, any> {
        protected getFormKey() { return CsSupplTypeForm.formKey; }
        protected getIdProperty() { return CsSupplTypeRow.idProperty; }
        protected getLocalTextPrefix() { return CsSupplTypeRow.localTextPrefix; }
        protected getNameProperty() { return CsSupplTypeRow.nameProperty; }
        protected getService() { return CsSupplTypeService.baseUrl; }
        protected getDeletePermission() { return CsSupplTypeRow.deletePermission; }
        protected getInsertPermission() { return CsSupplTypeRow.insertPermission; }
        protected getUpdatePermission() { return CsSupplTypeRow.updatePermission; }

        protected form = new CsSupplTypeForm(this.idPrefix);
        protected afterLoadEntity() {
            super.afterLoadEntity();
            
            var SupplType = Q.tryFirst(CsSupplierRow.getLookup().items, x => x.SupplType == this.entity.SupplType);
            if(SupplType !=null){
                this.deleteButton.toggleClass('disabled', true);
             
            }

        }
    }
}